export const ERROR_TYPE = {
  DEALER_ALREADY_CONTACTED: 'DEALER_ALREADY_CONTACTED',
  DEALER_NOT_FOUND: 'DEALER_NOT_FOUND',
  INVALID_USER: 'INVALID_USER',
  LASTCALL_ALREADY_EXISTS: 'LASTCALL_ALREADY_EXISTS',
  ORIGIN_NOT_SUITABLE_FOR_LC: 'ORIGIN_NOT_SUITABLE_FOR_LC'
}

export const LAST_CALL_STATE = {
  INIT: 'init',
  CONFIRMED: 'confirmed',
  [ERROR_TYPE.DEALER_NOT_FOUND]: ERROR_TYPE.DEALER_NOT_FOUND,
  [ERROR_TYPE.DEALER_ALREADY_CONTACTED]: ERROR_TYPE.DEALER_ALREADY_CONTACTED,
  [ERROR_TYPE.ORIGIN_NOT_SUITABLE_FOR_LC]: ERROR_TYPE.ORIGIN_NOT_SUITABLE_FOR_LC,
  ERROR: 'error'
}
export const BASE_CLASS = 'mt-ModalLastCall'
export const POST_CODE_PATTERN = /^(?:0[1-9]\d{3}|[1-4]\d{4}|5[0-2]\d{3})$/
export const POST_CODE_REGEXP = new RegExp(POST_CODE_PATTERN)
export const POSTCODE_ERRORS = {
  POSTCODE_REQUIRED: 'POSTCODE_REQUIRED',
  POSTCODE_INVALID: 'POSTCODE_INVALID'
}

export const TRACKS = {
  OPEN: 'New Vehicle Last Call Viewed',
  POSTCODE_ERROR: 'New Vehicle Last Call Postal Code Error',
  SUCCESS: 'New Vehicle Last Call Confirmed',
  FAILED: 'New Vehicle Last Call Not Generated',
  ERRORS: {
    POSTCODE_REQUIRED: 'Post Code Required',
    POSTCODE_INVALID: 'Invalid Post Code'
  }
}
